import React from 'react';
import { motion } from 'framer-motion';
import './PolicyPage.css';

const AccessibilityStatement = () => {
  return (
    <section className="policy-page section">
      <div className="container">
        <motion.div 
          className="policy-content"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1>♿ Accessibility Statement</h1>
          <p className="last-updated">Last updated: June 11, 2025</p>
          
          <p>At Digital Fig, we are committed to making our website accessible to everyone, regardless of technology or ability.</p>

          <h2>Our commitment</h2>
          <p>We strive to ensure www.digitalfig.com is:</p>
          <ul>
            <li>Perceivable, operable, understandable, and robust (WCAG 2.1 principles)</li>
            <li>Navigable via keyboard and screen readers</li>
            <li>Designed with sufficient colour contrast and readable typography</li>
          </ul>

          <h2>Steps we take</h2>
          <ul>
            <li>Use of semantic HTML and ARIA labels</li>
            <li>Regular audits and updates based on accessibility tools and user feedback</li>
            <li>Avoidance of flashing content or non-accessible media</li>
          </ul>

          <h2>Limitations</h2>
          <p>While we aim for full compliance, some third-party content or legacy features may not yet meet all standards. We continue to work towards improvements.</p>

          <h2>Feedback</h2>
          <p>If you encounter any accessibility barriers, please contact us:</p>
          <p>📧 <a href="mailto:hello@digitalfig.com">hello@digitalfig.com</a></p>
          <p>We value your feedback and aim to respond within 2 business days.</p>
        </motion.div>
      </div>
    </section>
  );
};

export default AccessibilityStatement;